import _ from 'underscore';
import getConfig from 'next/config';
import { parseISO } from 'date-fns';

import { getEntityUrl } from '../cultureUtils';
import { getEventNearestSeancePlace } from '../events';
import { logError } from '../logger';
import { getBaseMicrodata } from './helpers';
import { getGeoCoordinates } from './institute';

const {
	publicRuntimeConfig: { baseUrl }
} = getConfig();

export const getPrice = (event) => {
	let price = {
		minPrice: event.price.min,
		maxPrice: event.price.max
	};

	if (event.price.min === event.price.max) {
		price = {
			price: event.price.min
		};
	}

	return price;
};

export const getPlace = (event) => {
	const place = getEventNearestSeancePlace(event) || event.places[0];

	const placeData = {
		name: place.title,
		address: place.address
	};

	if (place.institute) {
		_(placeData).extend({
			name: place.title,
			geo: getGeoCoordinates(place.institute),
			address: placeData.address || place.institute.address
		});

		if (place.institute.status === 'published') {
			const placeUrl = `${baseUrl}${getEntityUrl(
				'institutes',
				place.institute
			)}`;

			_(placeData).extend({ url: placeUrl });
		}
	}

	return placeData;
};

export const getEventMicrodata = (event) => {
	let jsonData = {};

	try {
		const price = getPrice(event);
		const place = getPlace(event);

		jsonData = getBaseMicrodata(event, {
			type: 'Event',
			entityType: 'events'
		});

		_(jsonData).extend({
			startDate: parseISO(event.startDate),
			endDate: parseISO(event.endDate),
			offers: {
				'@type': 'Offer',
				price: price.minPrice || price.price,
				priceSpecification: _({
					'@type': 'PriceSpecification',
					priceCurrency: 'RUB'
				}).extend(price)
			},
			location: _({ '@type': 'Place' }).extend(place)
		});

		if (place.url) {
			jsonData.offers.url = place.url;
		}
	} catch (err) {
		logError(`event microdata error: ${err.stack || err}`);
	}

	return JSON.stringify(jsonData);
};
